import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 3v15a3 3 0 0 1 -6 0v-15","key":"svg-0"}],["path",{"d":"M9 12h6","key":"svg-1"}],["path",{"d":"M8 3h8","key":"svg-2"}]]

const IconTestPipe2 = createReactComponent('outline', 'test-pipe-2', 'TestPipe2', __iconNode);

export default IconTestPipe2;